import { CoverageIdEnum, PolicyProductIdEnum } from 'outshared-lib';
import {
    CoverageCollectionLabelEnum,
    CoverageGroupIdEnum,
    CoverageGroupLayoutEnum,
    CoverageGroupTypeEnum,
} from '../enums';
import { CoverageControlConfigInterface } from '../interfaces';

export const coverageControlConfig: CoverageControlConfigInterface = {
    [PolicyProductIdEnum.Liability]: [
        {
            label: CoverageCollectionLabelEnum.Default,
            groups: [
                {
                    id: CoverageGroupIdEnum.Liability,
                    type: CoverageGroupTypeEnum.Default,
                    options: { required: false },
                    inputs: [
                        {
                            id: CoverageIdEnum.Liability,
                            coverageIds: [CoverageIdEnum.Liability],
                        },
                    ],
                },
            ],
        },
    ],
    [PolicyProductIdEnum.Car]: [
        {
            label: CoverageCollectionLabelEnum.Base,
            groups: [
                {
                    id: CoverageGroupIdEnum.VehicleBase,
                    type: CoverageGroupTypeEnum.Table,
                    options: {
                        required: true,
                        layout: CoverageGroupLayoutEnum.Vertical,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.CarLegalLiability,
                            coverageIds: [CoverageIdEnum.CarDirectClaimsHandling, CoverageIdEnum.CarLegalLiability],
                        },
                        {
                            id: CoverageIdEnum.CarLimitedCasco,
                            coverageIds: [CoverageIdEnum.CarDirectClaimsHandling, CoverageIdEnum.CarLegalLiability, CoverageIdEnum.CarLimitedCasco],
                        },
                        {
                            id: CoverageIdEnum.CarLimitedCascoExtra,
                            coverageIds: [CoverageIdEnum.CarDirectClaimsHandling, CoverageIdEnum.CarLegalLiability, CoverageIdEnum.CarLimitedCascoExtra],
                        },
                        {
                            id: CoverageIdEnum.CarAllrisk,
                            coverageIds: [CoverageIdEnum.CarDirectClaimsHandling, CoverageIdEnum.CarLegalLiability, CoverageIdEnum.CarAllrisk],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.CarRedressLegalAid,
                    type: CoverageGroupTypeEnum.Implicit,
                    options: { required: true, layout: CoverageGroupLayoutEnum.Card },
                    inputs: [
                        {
                            id: CoverageIdEnum.CarRedressLegalAid,
                            coverageIds: [CoverageIdEnum.CarRedressLegalAid],
                        },
                    ],
                },
            ],
         },
        {
            label: CoverageCollectionLabelEnum.Extra,
            groups: [
                {
                    id: CoverageGroupIdEnum.RoadsideAssistance,
                    type: CoverageGroupTypeEnum.Toggle,
                    options: {
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.CarRoadsideAssistanceNetherlands,
                            coverageIds: [CoverageIdEnum.CarRoadsideAssistanceNetherlands],
                        },
                        {
                            id: CoverageIdEnum.CarRoadsideAssistanceEurope,
                            coverageIds: [
                                CoverageIdEnum.CarRoadsideAssistanceEurope,
                                CoverageIdEnum.CarRoadsideAssistanceNetherlands,
                            ],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.CarDamageInsuranceOccupants,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.CarDamageInsuranceOccupants,
                            coverageIds: [CoverageIdEnum.CarDamageInsuranceOccupants],
                            featured: true,
                        },
                    ],
                },
            ],
        },
    ],
    [PolicyProductIdEnum.Moped]: [
        {
            label: CoverageCollectionLabelEnum.Base,
            groups: [
                {
                    id: CoverageGroupIdEnum.Moped,
                    type: CoverageGroupTypeEnum.Radio,
                    options: {
                        required: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.MopedLegalLiability,
                            coverageIds: [CoverageIdEnum.MopedLegalLiability],
                        },
                        {
                            id: CoverageIdEnum.MopedLimitedCasco,
                            coverageIds: [CoverageIdEnum.MopedLegalLiability, CoverageIdEnum.MopedLimitedCasco],
                        },
                        {
                            id: CoverageIdEnum.MopedAllrisk,
                            coverageIds: [CoverageIdEnum.MopedLegalLiability, CoverageIdEnum.MopedAllrisk],
                        },
                    ],
                },
            ],
        },
    ],
    [PolicyProductIdEnum.Caravan]: [
        {
            label: CoverageCollectionLabelEnum.Base,
            groups: [
                {
                    id: CoverageGroupIdEnum.Caravan,
                    type: CoverageGroupTypeEnum.Radio,
                    options: {
                        required: true,
                        single: true,
                        layout: CoverageGroupLayoutEnum.Vertical,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.CaravanAllriskBenelux,
                            coverageIds: [CoverageIdEnum.CaravanAllriskBenelux],
                        },
                        {
                            id: CoverageIdEnum.CaravanAllriskEurope,
                            coverageIds: [CoverageIdEnum.CaravanAllriskEurope],
                        },
                    ],
                },
            ],
        },
        {
            label: CoverageCollectionLabelEnum.Extra,
            groups: [
                {
                    id: CoverageGroupIdEnum.CaravanHouseholdEffects,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.CaravanHouseholdEffects,
                            coverageIds: [CoverageIdEnum.CaravanHouseholdEffects],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.CaravanExtra,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.CaravanExtra,
                            coverageIds: [CoverageIdEnum.CaravanExtra],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.CaravanHail,
                    type: CoverageGroupTypeEnum.Dynamic,
                    options: {
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.CaravanHailEurope,
                            dependsOn: CoverageIdEnum.CaravanAllriskEurope,
                            coverageIds: [CoverageIdEnum.CaravanHailEurope],
                        },
                        {
                            id: CoverageIdEnum.CaravanHailBenelux,
                            dependsOn: CoverageIdEnum.CaravanAllriskBenelux,
                            coverageIds: [CoverageIdEnum.CaravanHailBenelux],
                        },
                    ],
                },
            ],
        },
    ],
    [PolicyProductIdEnum.Pet]: [
        {
            label: CoverageCollectionLabelEnum.Base,
            groups: [
                {
                    id: CoverageGroupIdEnum.PetBase,
                    type: CoverageGroupTypeEnum.Implicit,
                    options: {
                        required: true,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.PetInsurance,
                            coverageIds: [CoverageIdEnum.PetInsurance],
                        },
                    ],
                }
            ],
        },
        {
            label: CoverageCollectionLabelEnum.Extra,
            groups: [
                {
                    id: CoverageGroupIdEnum.PetExtraCoverage,
                    type: CoverageGroupTypeEnum.Disabled,
                    options: {
                        required: true,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.PetExtraCoverage,
                            coverageIds: [CoverageIdEnum.PetExtraCoverage],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.PetCancerTreatment,
                    type: CoverageGroupTypeEnum.Disabled,
                    options: {
                        required: true,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.PetCancerTreatment,
                            coverageIds: [CoverageIdEnum.PetCancerTreatment],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.PetTeeth,
                    type: CoverageGroupTypeEnum.Disabled,
                    options: {
                        required: true,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.PetTeeth,
                            coverageIds: [CoverageIdEnum.PetTeeth],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.PetCrem,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        hidden: true,
                        required: true,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.PetCrem,
                            coverageIds: [CoverageIdEnum.PetCrem],
                        },
                    ],
                },
            ],
        },
    ],
    [PolicyProductIdEnum.Motorcycle]: [
        {
            label: CoverageCollectionLabelEnum.Base,
            groups: [
                {
                    id: CoverageGroupIdEnum.VehicleBase,
                    type: CoverageGroupTypeEnum.Radio,
                    options: {
                        required: true,
                        layout: CoverageGroupLayoutEnum.Vertical,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.MotorLimitedCasco,
                            coverageIds: [CoverageIdEnum.MotorDirectClaimsHandling, CoverageIdEnum.MotorLimitedCasco],
                        },
                        {
                            id: CoverageIdEnum.MotorInStorage,
                            coverageIds: [CoverageIdEnum.MotorDirectClaimsHandling, CoverageIdEnum.MotorLimitedCasco, CoverageIdEnum.MotorInStorage],
                        },
                        {
                            id: CoverageIdEnum.MotorAllrisk,
                            coverageIds: [CoverageIdEnum.MotorDirectClaimsHandling, CoverageIdEnum.MotorLimitedCasco, CoverageIdEnum.MotorAllrisk],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.MotorRedressLegalAid,
                    type: CoverageGroupTypeEnum.Implicit,
                    options: {
                        required: true,
                        layout: CoverageGroupLayoutEnum.Card,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.MotorRedressLegalAid,
                            coverageIds: [CoverageIdEnum.MotorRedressLegalAid],
                        },
                    ],
                },
            ],
        },
        {
            label: CoverageCollectionLabelEnum.Extra,
            groups: [
                {
                    id: CoverageGroupIdEnum.MotorDamageInsuranceOpputants,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.MotorDamageInsuranceOpputants,
                            coverageIds: [CoverageIdEnum.MotorDamageInsuranceOpputants],
                            featured: true,
                        },
                    ],
                },
            ],
        },
    ],
    [PolicyProductIdEnum.Accidents]: [
        {
            label: CoverageCollectionLabelEnum.Default,
            groups: [
                {
                    id: CoverageGroupIdEnum.MotorAccidentPermanentInjury,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.MotorAccidentPermanentInjury,
                            coverageIds: [CoverageIdEnum.MotorAccidentPermanentInjury],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.MotorAccidentDeath,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.MotorAccidentDeath,
                            coverageIds: [CoverageIdEnum.MotorAccidentDeath],
                        },
                    ],
                },
            ],
        },
    ],
    [PolicyProductIdEnum.LegalAssistance]: [
        {
            label: CoverageCollectionLabelEnum.Default,
            groups: [
                {
                    id: CoverageGroupIdEnum.LegalConsumerAndHome,
                    type: CoverageGroupTypeEnum.Card,
                    options: {
                        required: false,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.LegalAssistanceConsumerAndLiving,
                            coverageIds: [CoverageIdEnum.LegalAssistanceConsumerAndLiving],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.LegalWorkAndIncome,
                    type: CoverageGroupTypeEnum.Card,
                    options: { required: false, hasBorder: true },
                    inputs: [
                        {
                            id: CoverageIdEnum.LegalAssistanceWorkAndIncome,
                            coverageIds: [CoverageIdEnum.LegalAssistanceWorkAndIncome],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.LegalFamilyAndWealth,
                    type: CoverageGroupTypeEnum.Card,
                    options: { required: false, hasBorder: true },
                    inputs: [
                        {
                            id: CoverageIdEnum.LegalAssistanceFamilyAndWealth,
                            coverageIds: [CoverageIdEnum.LegalAssistanceFamilyAndWealth],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.LegalWorldwide,
                    type: CoverageGroupTypeEnum.Card,
                    options: {
                        required: false,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.LegalAssistanceAccidentAndTraffic,
                            coverageIds: [CoverageIdEnum.LegalAssistanceAccidentAndTraffic],
                        },
                    ],
                },
            ],
        },
    ],
    [PolicyProductIdEnum.Travel]: [
        {
            label: CoverageCollectionLabelEnum.Base,
            groups: [
                {
                    id: CoverageGroupIdEnum.TravelEurope,
                    type: CoverageGroupTypeEnum.Implicit,
                    options: {
                        required: true,
                        hasBorder: true,
                    },
                    inputs: [
                        { id: CoverageIdEnum.TravelEurope, coverageIds: [CoverageIdEnum.TravelEurope] },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.TravelWorld,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                        hasBorder: true,
                    },
                    inputs: [
                        { id: CoverageIdEnum.TravelWorld, coverageIds: [CoverageIdEnum.TravelWorld] },
                    ],
                },
            ],
        },
        {
            label: CoverageCollectionLabelEnum.Extra,
            groups: [
                {
                    id: CoverageGroupIdEnum.TravelVehicleAssistance,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.TravelVehicleAssistance,
                            coverageIds: [CoverageIdEnum.TravelVehicleAssistance],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.TravelCancellation,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.TravelCancellation,
                            coverageIds: [CoverageIdEnum.TravelCancellation],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.TravelMedicalCost,
                    type: CoverageGroupTypeEnum.Dynamic,
                    options: {
                        required: false,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.TravelMedicalCostWorld,
                            dependsOn: CoverageIdEnum.TravelWorld,
                            coverageIds: [
                                CoverageIdEnum.TravelMedicalCostEurope,
                                CoverageIdEnum.TravelMedicalCostWorld,
                            ],
                        },
                        {
                            id: CoverageIdEnum.TravelMedicalCostEurope,
                            dependsOn: CoverageIdEnum.TravelEurope,
                            coverageIds: [
                                CoverageIdEnum.TravelMedicalCostEurope,
                            ],
                        },
                    ],
                },
            ],
        },
    ],
    [PolicyProductIdEnum.Home]: [
        {
            label: CoverageCollectionLabelEnum.Base,
            groups: [
                {
                    id: CoverageGroupIdEnum.HomeHouseholdEffectStandard,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                        layout: CoverageGroupLayoutEnum.Bordered,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.HomeHouseholdEffectStandard,
                            coverageIds: [CoverageIdEnum.HomeHouseholdEffectStandard],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.HomeBuildingStandard,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                        layout: CoverageGroupLayoutEnum.Bordered,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.HomeBuildingStandard,
                            coverageIds: [CoverageIdEnum.HomeBuildingStandard],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.HomeOwnerTenantInterest,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                        layout: CoverageGroupLayoutEnum.Bordered,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.HomeOwnerTenantInterest,
                            coverageIds: [CoverageIdEnum.HomeOwnerTenantInterest],
                        },
                    ],
                },
            ],
        },
        {
            label: CoverageCollectionLabelEnum.Extra,
            groups: [
                {
                    id: CoverageGroupIdEnum.HomeGlass,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.HomeGlass,
                            coverageIds: [CoverageIdEnum.HomeGlass],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.HomeMobileElectronics,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.HomeMobileElectronics,
                            coverageIds: [CoverageIdEnum.HomeMobileElectronics],
                        },
                    ],
                },
                {
                    id: CoverageGroupIdEnum.HomeComplete,
                    type: CoverageGroupTypeEnum.Dynamic,
                    options: {
                        required: false,
                        dynamicNaming: false,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.HomeBuildingComplete,
                            dependsOn: [
                                CoverageIdEnum.HomeBuildingStandard,
                                CoverageIdEnum.HomeOwnerTenantInterest,
                                CoverageIdEnum.HomeHouseholdEffectStandard,
                            ],
                            coverageIds: [
                                CoverageIdEnum.HomeBuildingComplete,
                                CoverageIdEnum.HomeOwnerTenantInterestComplete,
                                CoverageIdEnum.HomeHouseholdEffectsComplete,
                            ],
                        },
                        {
                            id: CoverageIdEnum.HomeHouseholdEffectsComplete,
                            dependsOn: [
                                CoverageIdEnum.HomeOwnerTenantInterest,
                                CoverageIdEnum.HomeHouseholdEffectStandard,
                            ],
                            coverageIds: [
                                CoverageIdEnum.HomeOwnerTenantInterestComplete,
                                CoverageIdEnum.HomeHouseholdEffectsComplete,
                            ],
                        },
                        {
                            id: CoverageIdEnum.HomeBuildingComplete,
                            dependsOn: [
                                CoverageIdEnum.HomeBuildingStandard,
                                CoverageIdEnum.HomeOwnerTenantInterest,
                            ],
                            coverageIds: [
                                CoverageIdEnum.HomeBuildingComplete,
                                CoverageIdEnum.HomeOwnerTenantInterestComplete,
                            ],
                        },
                        {
                            id: CoverageIdEnum.HomeBuildingComplete,
                            dependsOn: [
                                CoverageIdEnum.HomeBuildingStandard,
                                CoverageIdEnum.HomeHouseholdEffectStandard,
                            ],
                            coverageIds: [
                                CoverageIdEnum.HomeBuildingComplete,
                                CoverageIdEnum.HomeHouseholdEffectsComplete,
                            ],
                        },
                        {
                            id: CoverageIdEnum.HomeBuildingComplete,
                            dependsOn: CoverageIdEnum.HomeBuildingStandard,
                            coverageIds: [
                                CoverageIdEnum.HomeBuildingComplete,
                            ],
                        },
                        {
                            id: CoverageIdEnum.HomeOwnerTenantInterestComplete,
                            dependsOn: CoverageIdEnum.HomeOwnerTenantInterest,
                            coverageIds: [
                                CoverageIdEnum.HomeOwnerTenantInterestComplete,
                            ],
                        },
                        {
                            id: CoverageIdEnum.HomeHouseholdEffectsComplete,
                            dependsOn: CoverageIdEnum.HomeHouseholdEffectStandard,
                            coverageIds: [
                                CoverageIdEnum.HomeHouseholdEffectsComplete,
                            ],
                        },
                        {
                            id: CoverageIdEnum.HomeBuildingComplete,
                            dependsOn: [],
                            coverageIds: [CoverageIdEnum.HomeHouseholdEffectsComplete],
                        },
                    ],
                },
            ],
        },
    ],
    [PolicyProductIdEnum.Bicycle]: [
        {
            label: CoverageCollectionLabelEnum.Base,
            groups: [
                {
                    id: CoverageGroupIdEnum.VehicleBase,
                    type: CoverageGroupTypeEnum.Table,
                    options: {
                        required: true,
                        layout: CoverageGroupLayoutEnum.Vertical,
                    },
                    inputs: [
                        { id: CoverageIdEnum.BicycleTheft, coverageIds: [CoverageIdEnum.BicycleTheft] },
                        { id: CoverageIdEnum.BicycleAllrisk, coverageIds: [CoverageIdEnum.BicycleAllrisk] },
                    ],
                },
            ],
        },
        {
            label: CoverageCollectionLabelEnum.Extra,
            groups: [
                {
                    id: CoverageGroupIdEnum.BicycleHomeDeliveryService,
                    type: CoverageGroupTypeEnum.Default,
                    options: {
                        required: false,
                        hasBorder: true,
                    },
                    inputs: [
                        {
                            id: CoverageIdEnum.BicycleHomeDeliveryService,
                            coverageIds: [CoverageIdEnum.BicycleHomeDeliveryService],
                        },
                    ],
                },
            ],
        },
    ],
};
